const NON_SCALING_CONTROLS = {
  bl: false,
  br: false,
  mb: false,
  ml: false,
  mr: false,
  mt: false,
  tl: false,
  tr: false,
  mtr: true,
};

export const disableBrandScaling = (target) => {
  if (!target) {
    return target;
  }

  target.set?.({
    lockScalingX: true,
    lockScalingY: true,
    lockUniScaling: true,
  });
  target.setControlsVisibility?.(NON_SCALING_CONTROLS);
  target.getObjects?.().forEach(disableBrandScaling);
  return target;
};
